'use client';

import { Switch } from '@headlessui/react';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

export function PrivacyPolicy({ content }: { content: string }) {
  const [approved, setApproved] = useState(false);
  const [disable, setDisable] = useState(false);

  const approveHandle = () => {
    setApproved(true);
    setDisable(true);
    localStorage.setItem('privacyPolicyApproved', 'true');
  };

  useEffect(() => {
    const pp = localStorage.getItem('privacyPolicyApproved');
    if (pp !== undefined && pp === 'true') {
      setApproved(true);
      setDisable(true);
    }
  }, []);

  return (
    <div className="container mx-auto max-w-5xl rounded-md border-2 border-slate-300 bg-white px-4 py-8 text-left text-black lg:px-8 lg:py-16">
      <section className="h-[calc(100svh-320px)] overflow-auto [&>h1]:text-2xl [&>h1]:font-semibold [&>h2]:text-xl [&>h2]:font-semibold [&>ul]:list-disc [&>ul]:pl-4">
        <ReactMarkdown>{content}</ReactMarkdown>
      </section>

      <span className="mt-8 inline-flex items-center">
        {disable ? (
          <p>Вы согласились с Политикой Конфиденциальности</p>
        ) : (
          <p>Даёте ли Вы согласие?</p>
        )}

        <Switch
          aria-label="тоггл"
          checked={approved}
          disabled={disable}
          onChange={approveHandle}
          className={`${approved ? 'bg-teal-900' : 'bg-teal-700'} ${disable ? 'cursor-not-allowed grayscale' : 'grayscale-0'} relative my-auto ml-4 inline-flex h-[17px] w-[37px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75`}
        >
          <span className="sr-only">Подтвердить</span>
          <span
            aria-hidden="true"
            className={`${approved ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-[13px] w-[13px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
          />
        </Switch>
      </span>
    </div>
  );
}
